import * as z from "zod/v4";

export const connectChargebacksStripe = {
  name: "connectChargebacksStripe" as const,
  input: z.object({ apiKey: z.string() }),
  output: z.object({ success: z.boolean() }),
};
